// Wraps content with fine gold corner brackets — an heirloom "framed" treatment.
export default function Framed({ children, className = "" }) {
  const corner = "pointer-events-none absolute h-7 w-7 border-gold/70 z-10";
  return (
    <div className={`relative ${className}`}>
      <div className="relative overflow-hidden">{children}</div>
      <span className={`${corner} left-2.5 top-2.5 border-l border-t`} />
      <span className={`${corner} right-2.5 top-2.5 border-r border-t`} />
      <span className={`${corner} bottom-2.5 left-2.5 border-b border-l`} />
      <span className={`${corner} bottom-2.5 right-2.5 border-b border-r`} />
    </div>
  );
}
